
import PostForm from "./PostForm";

const EditPost = () => {
  return <PostForm mode="edit" />;
};

export default EditPost;
